import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripHorizontal } from 'lucide-react';

export default function SortableWidget({ id, children, isDraggable = true }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: !isDraggable });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
    height: '100%',
    zIndex: isDragging ? 100 : 'auto',
  };

  return (
    <div ref={setNodeRef} style={style}>
      {isDraggable && (
        <div 
          {...attributes} 
          {...listeners}
          style={{
            position: 'absolute',
            top: '0.5rem',
            right: '0.5rem',
            cursor: 'grab',
            zIndex: 10,
            padding: '4px',
            borderRadius: '4px',
            backgroundColor: 'var(--bg-input)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.3,
            transition: 'opacity 0.2s',
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '0.3'}
          title="Drag to reorder"
        >
          <GripHorizontal size={16} color="var(--text-secondary)" />
        </div>
      )}
      {children}
    </div>
  );
}
